export default __webpack_public_path__ + "static/media/arrow_icon.52e5151a.svg";